/**
 * Centralized branding defaults for the SAGE frontend.
 *
 * Change values here to rebrand the entire application.
 * These are fallback defaults -- runtime branding is fetched
 * from the API and managed via the admin panel.
 */

export const BRANDING = {
  appName: 'SAGE',
  appShortName: 'SAGE',
  tagline: 'Study Analytics Generative Engine',

  colors: {
    primary: '#3B82F6',
    secondary: '#64748B',
    sidebarBg: '#0F172A',
    sidebarText: '#E2E8F0',
  },

  login: {
    title: 'SAGE Platform',
    subtitle: 'Study Analytics Generative Engine',
    description:
      'Enterprise-grade clinical trial data review and analysis platform for pharmaceutical and biotech companies.',
    features: [
      {
        title: 'Data Management',
        description: 'Review and manage clinical trial data across multiple studies',
      },
      {
        title: 'Advanced Analytics',
        description: 'Interactive visualizations and patient profiles',
      },
      {
        title: '21 CFR Part 11 Compliant',
        description: 'Full audit trail and regulatory compliance',
      },
    ],
  },

  footer: {
    companyName: 'AetherClinical',
    supportEmail: 'support@aetherclinical.com',
    supportUrl: 'https://support.aetherclinical.com',
    showPoweredBy: true,
    poweredByText: 'Powered by SAGE',
  },
} as const
